<ng-template #template>
  <div class="svc-question__adorner">
    <div class="svc-question__content svc-question__content--in-popup">
      <ng-template [component]="{ name: componentName, data: componentData }"></ng-template>
    </div>
  </div>
</ng-template>